import "./i18n";
import { Outlet, Route, Routes } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import { CookieBanner } from "./components/CookieBanner";
import { Layout } from "./components/Layout";
import { RequireAuth } from "./components/RequireAuth";
import { Logger } from "./logger";
import { CreateMatchPage } from "./pages/CreateMatchPage";
import { GuestDetailsPage } from "./pages/GuestDetailsPage";
import { HomePage } from "./pages/HomePage";
import { LandingPage } from "./pages/LandingPage";
import { LoginPage } from "./pages/LoginPage";
import { MatchStatusPage } from "./pages/MatchStatusPage";
import { NotFoundPage } from "./pages/NotFoundPage";
import { SettingsPage } from "./pages/SettingsPage";
import { ShareLinkPage } from "./pages/ShareLinkPage";
import { MatchResponse } from "./match-response";
import { Privacy } from "./privacy";

import "./styles/index.css";

Logger.init();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: true,
      retry: 1,
    },
  },
});

const MarketingLayout = () => (
  <div className="pp-marketing">
    <Outlet />
  </div>
);

const AppLayout = () => (
  <Layout>
    <Outlet />
  </Layout>
);

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <Routes>
        <Route element={<MarketingLayout />}>
          <Route index element={<LandingPage />} />
          <Route path="privacy" element={<Privacy />} />
        </Route>

        <Route element={<AppLayout />}>
          <Route path="app" element={<HomePage />} />
          <Route path="crear" element={<CreateMatchPage />} />
          <Route path="crear/jugadores" element={<GuestDetailsPage />} />
          <Route path="login" element={<LoginPage />} />
          <Route path="compartir" element={<ShareLinkPage />} />
          <Route path="partido/:matchId" element={<MatchStatusPage />} />
          <Route
            path="ajustes"
            element={
              <RequireAuth>
                <SettingsPage />
              </RequireAuth>
            }
          />
          <Route path="match/:matchId" element={<MatchResponse />} />
        </Route>

        <Route element={<MarketingLayout />}>
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
      <CookieBanner />
    </QueryClientProvider>
  );
};

export default App;
